export default "https://cdn-static.gokick.com/assets/33ce344a4b715ce65918e7685bcdda5ecb423fac/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";